import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FiChevronsLeft, FiChevronLeft, FiChevronsRight, FiChevronRight } from 'react-icons/fi';
import styles from './Pagination.module.scss';

class Pagination extends React.PureComponent {
  constructor (props, context) {
    super(props, context)
    this.state = {
      currentPage: this.props.currentPage || 1,
    }
  }

  handleClick (num) {
    this.setState({
      currentPage: num
    })

    this.props.handleClick && this.props.handleClick(num)
  }

  pagination(page, total) {
    var current = page,
        last = total,
        delta = 2,
        left = current - delta,
        right = current + delta + 1,
        range = [],
        rangeWithDots = [],
        l;

    for (let i = 1; i <= last; i++) {
        if (i === 1 || i === last || (i >= left && i < right)) {
            range.push(i);
        }
    }

    for (let i of range) {
        if (l) {
            if (i - l === 2) {
                rangeWithDots.push(l + 1);
            } else if (i - l !== 1) {
                rangeWithDots.push('...');
            }
        }
        rangeWithDots.push(i);
        l = i;
    }

    return rangeWithDots;
  }

  render () {
    const { align, currentPage, total } = this.props;
    const currPage = currentPage || this.state.currentPage;

    const strokeWidth = 2.5;
    return (
      <div className={classNames(styles.container, styles[align])}>
        {currPage > 1 && <FiChevronsLeft className={styles.button} value={'firstPage'} onClick={() => this.handleClick(1)} strokeWidth={strokeWidth - .5} />}
        {currPage > 1 && <FiChevronLeft className={classNames(styles.button, styles.singleChevron)} value={'previousPage'} onClick={() => this.handleClick(currPage - 1)} strokeWidth={strokeWidth} />}

        {this.pagination(currPage, parseInt(total)).map(num => {
          const active = num === currPage;
          return <button key={`page${num}`} value={num} className={classNames(styles.button,
            {[styles.active]: active,
            [styles.disable]: typeof num !== 'number'})}
            onClick={!active || typeof num === 'number' ? () => this.handleClick(num) : null}>
            {num}
          </button>})
        }

        {currPage < total && <FiChevronRight className={classNames(styles.button, styles.singleChevron)} value={'nextPage'} onClick={() => this.handleClick(currPage + 1)} strokeWidth={strokeWidth} />}
        {currPage < total &&  <FiChevronsRight className={styles.button} value={'lastPage'} onClick={() => this.handleClick(total)} strokeWidth={strokeWidth - .5} />}
      </div>
    )
  }
}

Pagination.propTypes = {
  /** align pagination */
  align: PropTypes.oneOf(['left', 'center', 'right']),
  /** current active page */
  currentPage: PropTypes.number,
  /** total number of pages */
  total: PropTypes.number.isRequired,
  /** Function called upon click and returns the clicked page number */
  handleClick: PropTypes.func
}

Pagination.defaultProps = {
  align: 'right'
};

export default Pagination
